const routes = [
    {
        path: "/internship/application/form",
        component: () => import("../pages/student/InternshipApplicationForm.vue"),
        meta: {
            isAuthenticated: true,
            isStudent: true
        }
    },
    {
        path: "/internship/applications",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'internshipapplication_index'
        }
    },
    {
        path: "/internship/applications/:id",
        component: () => import("../pages/Detail"),
        meta: {
            isAuthenticated: true,
            permission: "internshipapplication_show"
        }
    }
];

export default routes;
